import { AlertTitle as MuiAlertTitle, type AlertTitleProps as MuiAlertTitleProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiAlertTitleProps, 'color'>>;

export function AlertTitle(props: Props) {
  return <MuiAlertTitle {...props} />;
}

export type { Props as AlertTitleProps };
